const translations = {
  "en": {
    "Banking": "Banking",
    "Brokerage, retirement and crypto": "Brokerage, retirement and crypto",
    "Checking, savings and credit": "Checking, savings and credit",
    "Invest": "Invest",
    "Link a bank or card and I'll watch your spending and balances.": "Link a bank or card and I'll watch your spending and balances.",
    "Link a brokerage, 401(k) or crypto wallet and I'll track your holdings.": "Link a brokerage, 401(k) or crypto wallet and I'll track your holdings.",
    "Non-invest": "Non-invest",
    "View dashboard": "View dashboard",
    "View portfolio": "View portfolio"
  },
  "zh-tw": {
    "Banking": "銀行",
    "Brokerage, retirement and crypto": "券商、退休帳戶與加密貨幣",
    "Checking, savings and credit": "支票帳戶、儲蓄帳戶與信用帳戶",
    "Invest": "投資",
    "Link a bank or card and I'll watch your spending and balances.": "連結銀行或卡片，Ed 將為您追蹤支出與餘額。",
    "Link a brokerage, 401(k) or crypto wallet and I'll track your holdings.": "連結券商、401(k) 或加密貨幣錢包，我將為您追蹤持倉。",
    "Non-invest": "未投資",
    "View dashboard": "檢視儀表板",
    "View portfolio": "查看投資組合"
  }
};

export default translations;
